<div fxLayout="column" ngStyle.lt-md="padding: 0 1rem;">
  <!-- IE requires all fxLayout="column" elements to have the child contents wrapped in a plain div tag -->
  <div *ngIf="isBrowserIE; else noteDetailFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
    <ng-container *ngTemplateOutlet="noteDetailFlexColumnTemplate"></ng-container>
  </div>
</div>

<ng-template #noteDetailFlexColumnTemplate>
  <div fxLayout="column">
    <div class="display-text normal-paragraph-spacing" style="text-align: center" *ngIf="showSpinner">
      <mat-spinner color="accent" diameter="32"></mat-spinner>
    </div>
    <div fxLayout="column" *ngIf="!showSpinner && noteDetailType === noteDetailTypes.Loan">
      <div *ngIf="isBrowserIE; else noteDetailLoanFormFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
        <ng-container *ngTemplateOutlet="noteDetailLoanFormFlexColumnTemplate"></ng-container>
      </div>
    </div>
    <div fxLayout="column" *ngIf="!showSpinner && noteDetailType === noteDetailTypes.Esign">
      <div *ngIf="isBrowserIE; else noteDetailEsignFormFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
        <ng-container *ngTemplateOutlet="noteDetailEsignFormFlexColumnTemplate"></ng-container>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #noteDetailLoanFormFlexColumnTemplate>
  <div fxLayout="column" >
    <div class="display-text primary-dark-color-important">
      <b><span i18n="@@note-detail.form.title">note-detail.form.title</span></b>
    </div>
    <div class="display-text title-spacer">
      <span i18n="@@note-detail.form.loan.note-id.label">note-detail.form.loan.note-id.label</span>:&nbsp;{{ noteDetail.noteId }}
    </div>
    <div class="display-text">
      <span i18n="@@note-detail.form.loan.first-payment-date.label">note-detail.form.loan.first-payment-date.label</span>:&nbsp;{{
        noteDetail.firstPaymentDate | date: 'MM/dd/yyyy'
      }}
    </div>
    <div class="display-text">
      <span i18n="@@note-detail.form.loan.amount-financed.label">note-detail.form.loan.amount-financed.label</span>:&nbsp;{{
        noteDetail.amountFinanced | currency
      }}
    </div>
    <div class="display-text">
      <span i18n="@@note-detail.form.loan.schedule-payment-amount.label">note-detail.form.loan.schedule-payment-amount.label</span>:&nbsp;{{
        noteDetail.schedulePaymentAmount | currency
      }}
    </div>
    <div class="display-text">
      <span i18n="@@note-detail.form.loan.days-past-due.label">note-detail.form.loan.days-past-due.label</span>:&nbsp;{{
        noteDetail.daysPastDue
      }}
    </div>
    <div class="display-text">
      <b
        ><span i18n="@@note-detail.form.loan.late-fees-due.label">note-detail.form.loan.late-fees-due.label</span>:&nbsp;{{
          noteDetail.lateFeesDue | currency
        }}</b
      >
    </div>
    <div class="display-text">
      <span i18n="@@note-detail.form.loan.interest-current-balance.label">note-detail.form.loan.interest-current-balance.label</span
      >:&nbsp;{{ noteDetail.interestCurrentBalance | currency }}
    </div>
    <div class="display-text">
      <span i18n="@@note-detail.form.loan.payoff-amount.label">note-detail.form.loan.payoff-amount.label</span
      ><mat-icon
        class="tooltip-icon"
        matTooltip="{{ getToolTip('payoffAmount') }}"
        matTooltipPosition="after"
        matTooltipClass="tooltip-multi-line"
        >help_outline</mat-icon
      >:&nbsp;{{ noteDetail.payoffAmount | currency }}
    </div>
    <div class="display-text">
      <span i18n="@@note-detail.form.loan.max-interest-rate.label">note-detail.form.loan.max-interest-rate.label</span
      ><mat-icon
        class="tooltip-icon"
        matTooltip="{{ getToolTip('maxInterestRate') }}"
        matTooltipPosition="after"
        matTooltipClass="tooltip-multi-line"
        >help_outline</mat-icon
      >:&nbsp;{{ noteDetail.maxInterestRate | percent: '1.2' }}
    </div>
    <div class="display-text">
      <span i18n="@@note-detail.form.loan.contract-interest-rate.label">note-detail.form.loan.contract-interest-rate.label</span
      ><mat-icon
        class="tooltip-icon"
        matTooltip="{{ getToolTip('contractInterestRate') }}"
        matTooltipPosition="after"
        matTooltipClass="tooltip-multi-line"
        >help_outline</mat-icon
      >:&nbsp;{{ noteDetail.contractInterestRate | percent: '1.2' }}
    </div>
    <div class="display-text">
      <span i18n="@@note-detail.form.loan.application-fee-detail.label">note-detail.form.loan.application-fee-detail.label</span>:&nbsp;{{
        (noteDetail.applicationFee !== null ? noteDetail.applicationFee : 0.0) | currency
      }}
    </div>
    <div class="display-text">
      <span i18n="@@note-detail.form.loan.interest-paid-prior-year.label">note-detail.form.loan.interest-paid-prior-year.label</span
      >:&nbsp;{{ noteDetail.interestPaidPriorYear | currency }}
    </div>
    <div class="display-text">
      <span i18n="@@note-detail.form.loan.lender-name.label">note-detail.form.loan.lender-name.label</span>:&nbsp;{{
        noteDetail.lenderName
      }}
    </div>
    <div class="display-text">
      <span i18n="@@note-detail.form.loan.num-paymnts-paid.label">note-detail.form.loan.num-paymnts-paid.label</span>:&nbsp;{{
        noteDetail.numPaymntsPd
      }}
    </div>
    <div class="display-text">
      <span i18n="@@note-detail.form.loan.num-paymnts-remain.label">note-detail.form.loan.num-paymnts-remain.label</span>:&nbsp;{{
        noteDetail.numPaymntsRm
      }}
    </div>
  </div>
</ng-template>

<ng-template #noteDetailEsignFormFlexColumnTemplate>
  <div fxLayout="column" >
    <div class="display-text primary-dark-color-important">
      <b><span i18n="@@note-detail.form.title">note-detail.form.title</span></b>
    </div>
    <div class="display-text title-spacer">
      <span i18n="@@note-detail.form.esign.note-id.label">note-detail.form.esign.note-id.label</span>:&nbsp;{{ esignNoteDetail.noteId }}
    </div>
    <div class="display-text">
      <span i18n="@@note-detail.form.esign.note-date.label">note-detail.form.esign.note-date.label</span>:&nbsp;{{
        esignNoteDetail.noteDate | date: 'MM/dd/yyyy'
      }}
    </div>
    <div class="display-text">
      <span i18n="@@note-detail.form.esign.amount-financed.label">note-detail.form.esign.amount-financed.label</span>:&nbsp;{{
        esignNoteDetail.amountFinanced | currency
      }}
    </div>
    <div class="display-text">
      <span i18n="@@note-detail.form.esign.finance-charge.label">note-detail.form.esign.finance-charge.label</span>:&nbsp;{{
        esignNoteDetail.financeCharge | currency
      }}
    </div>
    <div class="display-text">
      <span i18n="@@note-detail.form.esign.total-payments.label">note-detail.form.esign.total-payments.label</span>:&nbsp;{{
        esignNoteDetail.totalPayments | currency
      }}
    </div>
    <div class="display-text">
      <span i18n="@@note-detail.form.esign.interest-rate.label">note-detail.form.esign.interest-rate.label</span>:&nbsp;{{
        esignNoteDetail.interestRate | percent: '1.2'
      }}
    </div>
    <div class="display-text">
      <span i18n="@@note-detail.form.esign.graduation-date.label">note-detail.form.esign.graduation-date.label</span>:&nbsp;{{
        esignNoteDetail.graduationDate | date: 'MM/dd/yyyy'
      }}
    </div>
  </div>
</ng-template>
